/* SolutionSwitcherSectionComponent.js */

"use strict";
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./SolutionSwitcherSectionRenderer");

class SolutionSwitcherSectionComponent extends EventEmitter {
    constructor(logger, router, solutionManager, can) {
        super();
        this._solutionManager = solutionManager;
        this._can = can;
        this._renderer = new Renderer(this);

        this._logger = logger;
        this._router = router;

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {
    }

    _unregisterListeners() {

    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown()
            .then(() => this._renderer = undefined)
            .catch(() => {
                //TODO - Handle any errors in shutting down.
            });
    }
    get solutionManager(){
        return this._solutionManager;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onActiveOrganizationChanged(orgObj){
        this.emit('activeOrganizationChanged',orgObj);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */

    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

SolutionSwitcherSectionComponent.$inject = [
    '$teve.logger',
    '$teve.router',
    '$teve.solutionsManager',
    '$teve.controlAppNav'
];

module.exports = SolutionSwitcherSectionComponent;